import type { IconProps } from './types'

export const FlagEnIcon = ({ className }: IconProps) => {
  return (
    <svg
      viewBox="0 0 64 48"
      className={className}
      aria-hidden="true"
    >
      <rect width="64" height="48" rx="8" fill="#1F4AA8" />
      <path d="M0 0L64 48M64 0L0 48" stroke="#fff" strokeWidth="10" />
      <path d="M0 0L64 48M64 0L0 48" stroke="#D92332" strokeWidth="5" />
      <path d="M32 0V48M0 24H64" stroke="#fff" strokeWidth="16" />
      <path d="M32 0V48M0 24H64" stroke="#D92332" strokeWidth="8" />
    </svg>
  )
}
